export default __webpack_public_path__ + "static/media/330_dummy2016-wellness01-de.41f7e96a.png";